export const PERM = {
  TEMPLATE: 'admin:template',
  DEPT: 'admin:dept',
  USER: 'admin:user',
  POST: 'admin:post',
  GROUP: 'admin:group',
  ROLE: 'admin:role',
  OPS: 'admin:ops',
  SCHEDULE: 'admin:schedule',
  REPORT: 'admin:report',
  PORTAL_CONTENT: 'admin:portal:content',
  PORTAL_DESIGN: 'admin:portal:design',
  PORTAL_REVIEW: 'admin:portal:review',
  AUDIT: 'admin:audit',
  DICT: 'admin:dict',
  OFFICE_SUPPLY: 'admin:office-supply',
  /** @deprecated 兼容旧权限 */
  ORG: 'admin:org'
}

export const ADMIN_MENU_GROUPS = [
  {
    label: '组织管理',
    children: [
      { path: '/admin/depts', label: '部门管理', permission: PERM.DEPT, icon: 'OfficeBuilding' },
      { path: '/admin/posts', label: '岗位管理', permission: PERM.POST, icon: 'CollectionTag' },
      { path: '/admin/groups', label: '用户组', permission: PERM.GROUP, icon: 'UserFilled' },
      { path: '/admin/users', label: '用户管理', permission: PERM.USER, icon: 'User' },
      { path: '/admin/roles', label: '权限管理', permission: PERM.ROLE, icon: 'Key' },
      { path: '/admin/dicts', label: '数据字典', permission: PERM.DICT, icon: 'Collection' },
      { path: '/admin/office-supplies', label: '办公用品', permission: PERM.OFFICE_SUPPLY, icon: 'Box' }
    ]
  },
  {
    label: '流程管理',
    children: [
      { path: '/admin/templates', label: '流程设计', permission: PERM.TEMPLATE, icon: 'Document' },
      {
        label: '流程运营',
        icon: 'Monitor',
        children: [
          { path: '/admin/instances', label: '流程监控', permission: PERM.OPS, icon: 'Monitor' },
          { path: '/admin/schedules', label: '定时发起', permission: PERM.SCHEDULE, icon: 'Clock' }
        ]
      }
    ]
  },
  {
    label: '门户管理',
    children: [
      { path: '/admin/portal/home-design', label: '首页设计', permission: PERM.PORTAL_DESIGN, icon: 'Grid' },
      {
        label: '公告管理',
        children: [
          { path: '/admin/portal/articles', label: '公告发布', permission: PERM.PORTAL_CONTENT, icon: 'Notebook' },
          { path: '/admin/portal/review', label: '公告审核', permission: PERM.PORTAL_REVIEW, icon: 'DocumentChecked' }
        ]
      }
    ]
  },
  {
    label: '数据报表',
    children: [
      { path: '/workspace/data-reports', label: '数据报表', permission: PERM.REPORT, icon: 'DataAnalysis' }
    ]
  },
  {
    label: '系统审计',
    children: [
      { path: '/admin/audit-logs', label: '操作审计', permission: PERM.AUDIT, icon: 'DocumentChecked' }
    ]
  }
]

function flattenMenuItems(nodes, result = []) {
  const list = nodes || []
  list.forEach((node) => {
    if (node.children?.length) {
      flattenMenuItems(node.children, result)
    } else if (node.path) {
      result.push(node)
    }
  })
  return result
}

/** 扁平菜单，供首页跳转等使用 */
export const ADMIN_MENU_ITEMS = flattenMenuItems(ADMIN_MENU_GROUPS)

export function hasAdminPermission(permissions, permission) {
  if (!permission) return true
  if (!permissions || !permissions.length) return false
  if (permissions.includes(permission)) return true
  if (permission === PERM.DEPT || permission === PERM.USER || permission === PERM.POST || permission === PERM.GROUP) {
    return permissions.includes(PERM.ORG)
  }
  if (permission === PERM.SCHEDULE) {
    return permissions.includes(PERM.OPS)
  }
  if (permission === PERM.OPS) {
    return permissions.includes(PERM.REPORT)
  }
  return false
}

export function getAdminHomePath(permissions) {
  const item = ADMIN_MENU_ITEMS.find((menu) => hasAdminPermission(permissions, menu.permission))
  return item ? item.path : '/workspace/home'
}

export const ADMIN_ROLE_SUPER = 'SUPER_ADMIN'

export function getDefaultHomePath(role, adminRoleCode, permissions) {
  if (role === 'ADMIN' && adminRoleCode === ADMIN_ROLE_SUPER) {
    return getAdminHomePath(permissions)
  }
  return '/workspace/home'
}

export function canAccessAdmin(role, permissions) {
  return role === 'ADMIN' && Array.isArray(permissions) && permissions.length > 0
}

export function formatAdminRoleName(roleName, role) {
  if (role !== 'ADMIN') return '-'
  return roleName || '未分配角色'
}

export function formatAdminRoleNames(roleNames, role) {
  if (role !== 'ADMIN') return '-'
  if (!roleNames?.length) return '未分配角色'
  return roleNames.join('、')
}

export const AUDIT_ACTION_TEXT = {
  LOGIN: '登录',
  LOGOUT: '登出',
  USER_CREATE: '新增用户',
  USER_UPDATE: '修改用户',
  USER_DISABLE: '停用用户',
  USER_ENABLE: '启用用户',
  USER_DELETE: '删除用户',
  DEPT_CREATE: '新增部门',
  DEPT_UPDATE: '修改部门',
  DEPT_DELETE: '删除部门',
  POST_CREATE: '新增岗位',
  POST_UPDATE: '修改岗位',
  POST_DELETE: '删除岗位',
  GROUP_CREATE: '新建用户组',
  GROUP_UPDATE: '更新用户组',
  GROUP_DELETE: '删除用户组',
  GROUP_MOVE: '调整用户组排序',
  ROLE_CREATE: '新建管理角色',
  ROLE_UPDATE: '更新管理角色',
  ROLE_DELETE: '删除管理角色',
  TEMPLATE_CREATE: '新建模板',
  TEMPLATE_UPDATE: '更新模板',
  TEMPLATE_DELETE: '删除模板',
  TEMPLATE_TOGGLE: '切换模板状态',
  CATEGORY_CREATE: '新建流程分类',
  CATEGORY_UPDATE: '更新流程分类',
  CATEGORY_DELETE: '删除流程分类',
  INSTANCE_TERMINATE: '作废流程',
  INSTANCE_SUSPEND: '挂起流程',
  INSTANCE_RESUME: '恢复流程',
  INSTANCE_JUMP: '强制跳转',
  INSTANCE_EXPORT: '导出实例',
  TASK_REASSIGN: '改派任务',
  TASK_REASSIGN_SUSPEND: '改派挂起',
  TASK_ADMIN_APPROVE: '代审同意',
  TASK_ADMIN_REJECT: '代审终止',
  SCHEDULE_CREATE: '新建定时计划',
  SCHEDULE_UPDATE: '更新定时计划',
  SCHEDULE_DELETE: '删除定时计划',
  SCHEDULE_ENABLE: '启用定时计划',
  SCHEDULE_DISABLE: '停用定时计划',
  SCHEDULE_RUN: '执行定时计划',
  OFFICE_SUPPLY_CREATE: '新增办公用品',
  OFFICE_SUPPLY_UPDATE: '修改办公用品',
  OFFICE_SUPPLY_STATUS: '切换办公用品状态',
  OFFICE_SUPPLY_STOCK_IN: '办公用品入库',
  OFFICE_SUPPLY_CATEGORY_CREATE: '新增办公用品分类',
  OFFICE_SUPPLY_CATEGORY_UPDATE: '修改办公用品分类',
  OFFICE_SUPPLY_CATEGORY_STATUS: '切换办公用品分类状态',
  OFFICE_SUPPLY_CATEGORY_DELETE: '删除办公用品分类'
}

export function auditActionText(action) {
  return AUDIT_ACTION_TEXT[action] || action
}
